export function numDeclination(n, textForms) {
  const m = Math.abs(n) % 100;
  const n1 = m % 10;
  if (m > 10 && m < 20) { return textForms[2]; }
  if (n1 > 1 && n1 < 5) { return textForms[1]; }
  if (n1 === 1) { return textForms[0]; }
  return textForms[2];
}
